// components/modals/CopyCodingFormModal.tsx
import React from 'react';
import ArrModal from '../../common/arr-modal/ArrModal';
import {
  useCopyCodingForm,
  useDeleteCodingForm,
} from '../../../hooks/document/useDocument';
import {ICodingListGridData} from '../../../api/types/document.type';
import {ToastType} from '../../../shared/constants';
import {t} from 'i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedForm: ICodingListGridData | null;
  triggerToast: (message: string, status: ToastType[]) => void;
  refetchCodingFormList: () => void;
}

const CopyCodingFormModal: React.FC<Props> = ({
  open,
  onClose,
  selectedForm,
  triggerToast,
  refetchCodingFormList,
}) => {
  const {mutate: copyCodingForm, reset: resetCopyCodingForm} =
    useCopyCodingForm();
  const {reset: resetDeleteCodingForm} = useDeleteCodingForm();

  const handleCopyClick = () => {
    resetCopyCodingForm();
    resetDeleteCodingForm();

    copyCodingForm(selectedForm?.codingFormId ?? '', {
      onSuccess: (data) => {
        triggerToast(data.message, [ToastType.Success]);
        refetchCodingFormList();
        onClose();
      },
      onError: (data, error) => {
        triggerToast(data.message || error, [ToastType.Error]);
        onClose();
      },
    });
  };

  return (
    <ArrModal
      showModal={open}
      onClose={() => onClose()}
      title={t('common.copy')}
      description={t('codingForms.manage.copyText')}
      dataTestId="copy-codingform-modal"
      buttons={[
        {
          id: '1',
          label: t('common.no'),
          onClick: () => onClose(),
          variant: 'secondary',
          dataTestId: 'copy-modal-cancel-btn',
        },
        {
          id: '2',
          label: t('common.yes'),
          onClick: () => handleCopyClick(),
          variant: 'primary',
          dataTestId: 'copy-modal-confirm-btn',
        },
      ]}
    />
  );
};

export default CopyCodingFormModal;
